// The shared quiz player (components/learn/QuizView.jsx), used by the course player.
// These ids moved here from the retired v2 pathways registry; the values are unchanged.
export const QUIZ = {
  quiz: "quiz-view",
  quizChoice: (questionId, index) => `quiz-choice-${questionId}-${index}`,
  quizOpenAnswer: (questionId) => `quiz-open-${questionId}`,
  quizSubmit: "quiz-submit",
  quizResult: "quiz-result",          // text contains the score
  quizAttemptsLeft: "quiz-attempts-left",
  quizError: "quiz-error",
};
